import { Card, Table } from '@design-systems/canvas-ui'
import { useEssentials } from 'hooks/utils/useEssentials'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { buildWhereRows } from './utils'
import type { WhereItsHappeningProps } from './types'
import { NoData } from '../no-data/no-data'

export const WhereItsHappening = ({ observations }: WhereItsHappeningProps) => {
    const { t } = useEssentials()
    const { details } = TRANSLATION_KEYS.insights

    const rows = buildWhereRows(
        observations,
        t(details.statusStrong),
        t(details.statusWeak),
    )

    if (rows.length === 0) return null

    const columnDefs = [
        {
            id: 'area',
            header: t(details.tableArea),
            isRowHeader: true,
            pinned: true,
            width: 160,
        },
        { id: 'value', header: t(details.tableValue), width: 90 },
        {
            id: 'comp_store',
            header: t(details.tableCompStore),
            width: 150,
        },
        {
            id: 'comp_district',
            header: t(details.tableCompDistrict),
            width: 150,
        },
        { id: 'status', header: t(details.tableStatus), width: 80 },
    ]

    return (
        <section className="hc8-mb-4x">
            <h2 className="hc8-clr-base hc8-fs-250 hc8-mb-1x">
                <strong>{t(details.whereItsHappening)}</strong>
            </h2>
            <Card className="hc8-ma-none table-scroll-container">
                {rows.length === 0 ? (
                    <NoData />
                ) : (
                    <Table
                        className="hc8-clr-base hc8-ma-none"
                        name={t(details.whereItsHappening)}
                        isCornerRounded={true}
                        isWidthScrollable
                        alternateRowColor={false}
                        data={{ columnDefs, rowData: rows }}
                    />
                )}
            </Card>
        </section>
    )
}
